const RevenueIncreaseIcon = () => {
    return (

<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M32.2835 8.88997V3.05664H26.4502" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M3.11719 22.015L14.0547 11.0775H24.263L32.2839 3.05664" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M24.9922 32.2236H32.2839" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M14.0547 32.2236H21.3464" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M3.11719 32.2236H10.4089" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M24.9922 27.8486H32.2839" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M14.0547 27.8486H21.3464" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M3.11719 27.8486H10.4089" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M24.9922 23.4736H32.2839" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M14.0547 23.4736H21.3464" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M24.9922 19.0986H32.2839" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M14.0547 19.0986H21.3464" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M24.9922 14.7236H32.2839" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
</svg>



    )
}



export default RevenueIncreaseIcon